<div class="app-intro">
    <app-side-paragraph style="margin-top: 20px; margin-bottom: 20px; display: none">
        {{ localizationKeys.aumico_reports_login_introduction | i18next }}
    </app-side-paragraph>
    <app-side-list hidden>
        <app-side-list-item
            *ngFor="let item of sideList"
            [text]="item.localizationKey | i18next"
            [icon]="item.iconName"
        ></app-side-list-item>
    </app-side-list>
</div>
